import { useEffect, useState } from 'react';
import { } from 'antd';
import "./worth.css"
import { getIndiaFormatCurrency } from "../../utils/util"
export default function Worth(props) {

    let totalInvested = 0
    let currentValue = 0
    let totalOneDayProfit = 0
    for (let t of props.transactions) {
        if (t.action == null || t.action == "Buy") {
            totalInvested += t.amount
            currentValue += t.currentValue
            totalOneDayProfit += t.oneDayProfit
        } else if (t.action == "Sell") {
            totalInvested -= t.amount
            currentValue -= t.currentValue
        }

    }
    let totalProfit = currentValue - totalInvested
    let gain = 100 * (currentValue - totalInvested) / totalInvested
    let oneDayProfitPercent = 100 * (totalOneDayProfit) / totalInvested

    let getProfitLossClass = () => {
        if (totalOneDayProfit > 0) {
            return "profit-green"
        }
        return "loss-red"

    }


    return (
        <div className="worth">
            <div className="worth-wrapper">
                <div className="worth-text">
                    Total Invested
                    <div>{getIndiaFormatCurrency(totalInvested)}</div>
                </div>
            </div>
            <div className="worth-wrapper">
                <div className="worth-text">
                    Current Value
                    <div>{getIndiaFormatCurrency(currentValue)}</div>

                </div>
            </div>
            <div className="worth-wrapper">
                <div className="worth-text">
                    Total Profit
                    <div>{getIndiaFormatCurrency(totalProfit)}({gain.toFixed(2)}%)</div>
                </div>
            </div>
            <div className={"worth-wrapper " + getProfitLossClass()}>
                <div className="worth-text">
                    Today Profit
                    <div >{getIndiaFormatCurrency(totalOneDayProfit)}({oneDayProfitPercent.toFixed(2)}%)</div>
                </div>
            </div>
        </div>
    )

}